module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "collapse",
    on: {
      "click": _vm.activeSwitch
    }
  }, [_c('a', {
    class: [_vm.isExpand ? 'entypo-up-circled' : 'entypo-down-circled'],
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isExpand ? '收起' : '展开') + "\n        "), _c('a', {
    staticClass: "expand"
  }, [_vm._t("default", [_vm._v(_vm._s(this.data.name))])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f503f33c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collapse.vue
// module id = 98
// module chunks = 0